import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { SAVE_RECORDING_METADATA } from './constants';
import {
  saveRecordingMetadataSuccess,
  saveRecordingMetadataFailure,
} from './actions';
import { normalizeError } from '../../helpers/utils';

export function* saveRecordingMetadata({ recordingData }) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const body = JSON.stringify(recordingData);

  try {
    const payload = yield call(
      axios.post,
      '/api/recording/metadata',
      body,
      config
    );
    yield put(saveRecordingMetadataSuccess(payload.data));
  } catch (err) {
    console.log(err.response);
    const error = normalizeError(err);
    yield put(saveRecordingMetadataFailure(error));
  }
}

// export function* getAllRecordings({ payload: filters }) {
//   try {
//     const response = yield call(axios.get, '/api/recording', {
//       params: filters,
//     });
//     const { data } = response;

//     yield put(getAllRecordingsSuccess(data));
//   } catch (err) {
//     const error = normalizeError(err);
//     yield put(getAllRecordingsError(error));
//   }
// }
export default function* videoLibrarySaga() {
  yield takeLatest(SAVE_RECORDING_METADATA, saveRecordingMetadata);
  // yield takeLatest(GET_ALL_RECORDINGS, getAllRecordings);
}
